"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRevieveResponse = formatRevieveResponse;
exports.formatHautApiResponse = formatHautApiResponse;
const mapping_1 = __importStar(require("./mapping"));
var APP_RANGE_VALUE;
(function (APP_RANGE_VALUE) {
    APP_RANGE_VALUE["HIGH"] = "high";
    APP_RANGE_VALUE["MEDIUM"] = "medium";
    APP_RANGE_VALUE["MEDIUM_HIGH"] = "mediumHigh";
    APP_RANGE_VALUE["MEDIUM_LOW"] = "mediumLow";
    APP_RANGE_VALUE["LOW"] = "low";
})(APP_RANGE_VALUE || (APP_RANGE_VALUE = {}));
var ATTRIBUTE_UNIT;
(function (ATTRIBUTE_UNIT) {
    ATTRIBUTE_UNIT["NUMBER"] = "number";
})(ATTRIBUTE_UNIT || (ATTRIBUTE_UNIT = {}));
function invertAttributeScore(attributeScore, appAttributeScale) {
    return appAttributeScale.max - attributeScore;
}
function getNormalizedScore(attributeScale, attributeScore, attributeType, appAttributeScale) {
    if (attributeType === mapping_1.AttributeType.NEUTRAL) {
        return attributeScore;
    }
    const appScale = appAttributeScale;
    const appScaleRange = appScale.max - appScale.min;
    const attributeScaleRange = attributeScale.max - attributeScale.min;
    const multiplier = appScaleRange / attributeScaleRange;
    const score = attributeScore * multiplier;
    return score;
}
function getAttributeStatus(score, id, appRange1) {
    const appRange = appRange1.find(i => i.id === id.toString()).range;
    if (score >= appRange.low.min && score <= appRange.low.max) {
        return APP_RANGE_VALUE.LOW;
    }
    else if (score >= appRange.mediumLow.min && score <= appRange.mediumLow.max) {
        return APP_RANGE_VALUE.MEDIUM_LOW;
    }
    else if (score >= appRange.medium.min && score <= appRange.medium.max) {
        return APP_RANGE_VALUE.MEDIUM;
    }
    else if (score >= appRange.mediumHigh.min && score <= appRange.mediumHigh.max) {
        return APP_RANGE_VALUE.MEDIUM_HIGH;
    }
    else if (score >= appRange.high.min && score <= appRange.high.max) {
        return APP_RANGE_VALUE.HIGH;
    }
}
function formatRevieveResponse(response, apiName, appRange, appAttributeScale) {
    const { results } = response;
    const formattedResponse = results.map(component => {
        var _a;
        const attributeName = mapping_1.default.revieve.attribute[`${component.description}`];
        const attributeProviders = ((_a = mapping_1.default.normalized[attributeName]) === null || _a === void 0 ? void 0 : _a.providers) || [];
        if (attributeName && attributeProviders.includes(apiName) && typeof component.value === 'number') {
            const attributeScale = mapping_1.default.normalized[attributeName][apiName].scale;
            const attributeType = mapping_1.default.normalized[attributeName][apiName].type;
            const attributeUnit = mapping_1.default.normalized[attributeName].unit;
            const normalizedScore = getNormalizedScore(attributeScale, component.value, attributeType, appAttributeScale);
            const attributeStatus = getAttributeStatus(normalizedScore, component.id, appRange);
            return {
                attribute: attributeName,
                type: attributeType,
                status: attributeStatus,
                unit: attributeUnit,
                score: normalizedScore,
            };
        }
        else {
            return {
                result: {
                    value: component.value,
                    attribute: component.description,
                },
            };
        }
    });
    response = Object.assign(Object.assign({}, response), { results: formattedResponse });
    return response;
}
function getHautSubattributesScore(componentResult = [{}]) {
    return componentResult.map(subattribute => {
        var _a;
        return {
            areaName: subattribute.area_name,
            score: ((_a = subattribute.main_metric) === null || _a === void 0 ? void 0 : _a.value) || null,
        };
    });
}
function getHautSkinAnalyserApiConfig(api, algorithms) {
    const algorithm = algorithms.reduce((total, curr) => {
        if (curr.enable) {
            total.push(curr.id);
        }
        return total;
    }, []);
    const apiConfig = {
        name: api,
        algorithms: algorithm,
    };
    return apiConfig;
}
function formatHautApiResponse(response, configuredAlgorithmsObject, apiName, appRange, appAttributeScale) {
    console.log('[skin.processor.formatHautApiResponse]', 'FORMATTING API RESPONSE');
    const { results } = response;
    const configuredAlgorithmsObj = getHautSkinAnalyserApiConfig(apiName, configuredAlgorithmsObject);
    const configuredAlgorithms = configuredAlgorithmsObj.algorithms;
    const formattedResponse = results.reduce((total, component) => {
        var _a, _b, _c, _d, _e, _f;
        const algorithmVersionId = component.algorithm_version_id;
        const attributeName = mapping_1.default.haut.algorithm_version_id[`${algorithmVersionId}`];
        const attributeProviders = ((_a = mapping_1.default.normalized[attributeName]) === null || _a === void 0 ? void 0 : _a.providers) || [];
        if (attributeName && attributeProviders.includes(apiName) && configuredAlgorithms.includes(algorithmVersionId.toString())) {
            const attributeValue = (_d = (_c = (_b = component.result) === null || _b === void 0 ? void 0 : _b.area_results[0]) === null || _c === void 0 ? void 0 : _c.main_metric) === null || _d === void 0 ? void 0 : _d.value;
            const attributeScale = mapping_1.default.normalized[attributeName][apiName].scale;
            const attributeUnit = mapping_1.default.normalized[attributeName].unit;
            const attributeType = mapping_1.default.normalized[attributeName][apiName].type;
            const attributeTechName = mapping_1.default.normalized[attributeName][apiName].attribute;
            const parentAttributeType = mapping_1.default.normalized[attributeName].parentAttributeType;
            const subAttributesScore = getHautSubattributesScore((_e = component.result) === null || _e === void 0 ? void 0 : _e.area_results);
            const masks = ((_f = component.result) === null || _f === void 0 ? void 0 : _f.masks_original) || null;
            let attributeScore = typeof attributeValue === ATTRIBUTE_UNIT.NUMBER ? attributeValue : 0;
            let attributeStatus = null;
            if (parentAttributeType !== mapping_1.AttributeType.NEUTRAL) {
                const normalizedScore = getNormalizedScore(attributeScale, attributeValue, attributeType, appAttributeScale);
                attributeScore = parentAttributeType !== attributeType ? invertAttributeScore(normalizedScore, appAttributeScale) : normalizedScore;
                attributeStatus = getAttributeStatus(attributeScore, algorithmVersionId, appRange);
            }
            total.push({
                attribute: attributeName,
                algorithmVersionId,
                algorithmTechName: attributeTechName,
                subattributes: subAttributesScore,
                type: parentAttributeType,
                status: attributeStatus,
                unit: attributeUnit,
                score: attributeScore,
                masks: { original: masks },
            });
        }
        return total;
    }, []);
    response = Object.assign(Object.assign({}, response), { results: formattedResponse });
    return response;
}
